import React from "react";

export const RightSideCountTop = (props) => {
  return (
    <div className="d-flex align-items-center">
      {props.content &&
        props.content.map((data, index) => (
          <div
            key={index}
            className="p-2 mr-3 pr-3"
            style={{
              backgroundColor: `${
                data.backgroundColor && data.backgroundColor
              }`,
              color: `${data.color && data.color}`,
              minWidth: "200px",
            }}
          >
            <div
              className="f12-500"
              style={{ color: `${data.color && data.color}` }}
            >
              {data.name && data.name}
            </div>
            <div className="f18-700">{data.value && data.value}</div>
          </div>
        ))}
    </div>
  );
};
